import { makeStyles } from "tss-react/mui";
import { MiIcon } from "@miplatform/components";
import { mdiChevronDown } from "@mdi/js";
import { Accordion, AccordionDetails, AccordionSummary } from "@mui/material";

export const InspectionAccordion = ({
  children,
  title,
  backgroundColor,
  count,
}: {
  children: React.ReactNode;
  title: string;
  backgroundColor: string;
  count: number;
}) => {
  const { classes, theme } = useStyles({ backgroundColor });
  return (
    <Accordion classes={{ root: classes.accordionRoot }} defaultExpanded>
      <AccordionSummary
        classes={{
          root: classes.summaryRoot,
          content: classes.summaryContent,
          expanded: classes.summaryExpanded,
        }}
        expandIcon={
          <MiIcon path={mdiChevronDown} color={theme.palette.common.white} />
        }
      >
        <span className={classes.count}>{count}</span>
        <span>{title}</span>
      </AccordionSummary>
      <AccordionDetails classes={{ root: classes.detailsRoot }}>
        {children}
      </AccordionDetails>
    </Accordion>
  );
};

const useStyles = makeStyles<{ backgroundColor: string }>()(
  (theme, { backgroundColor }) => ({
    accordionRoot: {
      backgroundColor: "transparent",
      boxShadow: "none",
      borderRadius: 0,

      "&:before": { display: "none" },
    },
    summaryRoot: {
      color: theme.palette.common.white,
      backgroundColor: backgroundColor ?? theme.palette.grey[500],
      fontSize: "0.75rem",
      fontWeight: 600,
      minHeight: theme.spacing(4),
      borderRadius: 4,
      border: `1px solid rgba(0,0,0, 0.2)`,
      "&.Mui-expanded": {
        minHeight: theme.spacing(4),
      },
    },
    summaryExpanded: {
      minHeight: theme.spacing(4),
    },
    summaryContent: {
      display: "flex",
      alignItems: "center",
      gap: 8,
      padding: 0,
      margin: 0,
      "&.Mui-expanded": {
        margin: 0,
      },
    },
    count: {
      backgroundColor: "rgba(0, 0, 0, 0.2)",
      fontWeight: 400,
      borderRadius: 50,
      height: 15,
      minWidth: 15,
      padding: theme.spacing(0, 1),
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    detailsRoot: {
      padding: theme.spacing(1, 0),
      backgroundColor: "transparent",
    },
  })
);
